import { FC } from 'react';
import { css, keyframes } from '@emotion/react';
import { borderRadius } from '../../styles';

interface Props {
  width: string;
}

const SkeletonBox: FC<Props> = ({ width }) => {
  const pulse = keyframes`
    0% 100% {
      background-color: #eeece9;
    }

    50% {
      background-color: #d9d6d2;
    }
  `;

  const style = css`
    width: ${width};
    animation: ${pulse} 1.4s ease-in-out infinite;
    background-color: #eeece9;
    border-radius: ${borderRadius};
  `;

  return (
    <div css={style}>
      <br />
    </div>
  );
};
export default SkeletonBox;
